
import { InstiService } from './insti.service';
import { InstiHelpers } from './instihelpers.module';

export class instiMenuItem{
          private item:any;
      private insti_service:InstiService;
      tipos:any[]=['link','saperator','subchild','sub','extTabLink'];
      getTipos(){ return this.tipos;}
      getTipo(){
          let l_item=this.getItem();
          return l_item.hasOwnProperty('type')? l_item.type : null;
      }
      isTipo(tipo?:string){ return this.getTipos().indexOf((!tipo? this.getTipo(): tipo ))>-1;}
      hasRules(){ return this.getItem().hasOwnProperty('rules'); } 
      getRules(){ return this.hasRules()? this.getItem().rules : null;}
     setShow(value){
        this.getItem()['show']=value===true? true : false;
        return this;
     }  
     getShow():boolean{ return this.getItem().hasOwnProperty('show')? this.getItem().show: true;}
     isShow(){ return this.getShow()===true;}
      private initService(){
        this.insti_service =new InstiService();
        return this;
    }
    getInstiService(){ return this.insti_service;}
    
     /**
      * @Description Aluisio Ferreira de Sousa atmmaster36@yahoo.com.br
      * 17/02/2020.
      * No momento as regras são baseadas no tipo do usuario.
      */
     private applyRules(){
         let parent_instance=this;
        return { 
            is_admin:function(){ 
                return parent_instance.getInstiService().getUser().isTipo('admin');
            },
            is_dev:function(){
                return parent_instance.getInstiService().getUser().isTipo('desenv');
                
            }
        }
     }
     /**
      * @Description Aluisio Ferreira de Sousa atmmaster36@yahoo.com.br
      * 17/02/2020
      * Verifica se um item do menu atende a regra especificada
      * como rules é opcional se não houver a propriedade rules considerar que o item é valido
      * Mesmo o 
      * @return BOOLEAN
      */
     isValid(){
         if(!this.hasRules()){ return true; }
          
        let helprs=new InstiHelpers();
        
        let l_rule=this.getRules();   
            
         if(helprs.isString(l_rule)){
            return this.applyRules().hasOwnProperty(this.getRules())? this.applyRules()[this.getRules()]() : false;
         }
         
         if(!helprs['isFunction'](l_rule)){
             return false;
         }
         let parent_instance=this;
         return l_rule(this.getItem(),parent_instance.getInstiService().getUser()) === true ? true: false;
     }
     
     /**
      * @TODO depois fazer metodos para as demais propriedades
      */
  //disabled?:boolean;
     
      constructor(menu_item){
         this.setItem(menu_item);
         this.initService();
      }
      private setItem(value){
          this.item=value;
          return this;
      }
      getItem(){ return this.item;}
 }
